fragment CartProductFields on CartProduct {
  key
  quantity
  total
  option {
    name
    value
    type
  }
  product {
    id
    name
    model
    sku
    price
    original_price
    image
    imageLazy
    extra {
      name
      value
    }
    manufacturer {
      id
      name
      url(url: "/store/manufacturer/_id")
    }
    special
    isFinalSale
  }
}

mutation addToCart($id: String, $quantity: Int, $options: [CartOption]) {
  addToCart(id: $id, quantity: $quantity, options: $options) {
    products {
      ...CartProductFields
    }
    total
  }
}

mutation updateCart($key: String, $quantity: Int) {
  updateCart(key: $key, quantity: $quantity) {
    products {
      ...CartProductFields
    }
    total
  }
}

mutation removeCart($key: String) {
  removeCart(key: $key) {
    products {
      ...CartProductFields
    }
    total
  }
}

query cart {
  cart {
    products {
      ...CartProductFields
    }
    total
    subtotal
    totals {
      code
      title
      value
      data
      sort_order
    }
  }
}
